import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { CREATE_NO_DEPT_PROJECT_LIST_ROLE_PREFIX_URL } from './constants/config.create-no-dept-project-list-role'

const ListPageCreateNoDeptProjectListRole = lazy(
  () => import('./pages/ListPage.CreateNoDeptProjectListRole')
)

const CreateNoDeptProjectListRoleRouters: AppRouterItem[] = [
  {
    path: CREATE_NO_DEPT_PROJECT_LIST_ROLE_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageCreateNoDeptProjectListRole />
      </LoadingLazyComponents>
    ),
  },
]

export default CreateNoDeptProjectListRoleRouters
